import React from 'react'
import './Meat.css'
import Teacher from './Teacher'
import {Divider} from "@chakra-ui/react"

function TeacherMeat() {
  return (
    <div className='experience'>
      <div className='head'>Meat Your Sb Pahtshala Instructors</div>
      <Divider
            h="5px"
            color="black"
            bgColor="black"
            mt="0Px"
          />
    </div>
  )
}

export default TeacherMeat